import { Toaster } from '@repo/ui/components/sonner';
import { createRootRoute, Outlet } from '@tanstack/react-router';
import { PreferencesProvider } from '../lib/preferences-provider';
import { ThemeProvider } from '../lib/theme-provider';

export const Route = createRootRoute({
  component: RootComponent,
});

function RootComponent() {
  return (
    <ThemeProvider>
      {/* PreferencesProvider inside ThemeProvider so it can bridge themeMode via useTheme() */}
      <PreferencesProvider>
        <div className="min-h-screen bg-background text-foreground">
          <Outlet />
          <Toaster />
        </div>
      </PreferencesProvider>
    </ThemeProvider>
  );
}
